import { render, staticRenderFns } from "./PartnerInfoBranches.vue?vue&type=template&id=0ba1eb91&scoped=true"
import script from "./PartnerInfoBranches.vue?vue&type=script&lang=js"
export * from "./PartnerInfoBranches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1eb91",
  null
  
)

export default component.exports